module.exports = fox._r("fonts/stateoff.ttf?c8mros", __webpack_public_path__ + "_/_/_/root/fonts/2Pd2-cS.ttf");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/fonts/stateoff.ttf?c8mros
// module id = 437
// module chunks = 4